import clsx from 'clsx';

import styles from './CardSkeleton.module.scss';

type CardSkeletonProps = {
  height?: string | number;
  className?: string;
};

const CardSkeleton = ({ className, height = 60 }: CardSkeletonProps) => {
  return <div className={clsx(styles.cardSkeleton, className)} style={{ height }} />;
};

export default CardSkeleton;
